export default __webpack_public_path__ + "static/media/logo.245606d0.svg";